export class BulkGatewaysTransactionRow{
  mac?: string
  result?: boolean
  status?: string

  constructor(params?: Partial<BulkGatewaysTransactionRow>) {
    Object.assign(this, params)
  }
}
